import dgv from "@assets/logo.png";
import Spacer from "@components/Spacer";
import AbsoluteBackButton from "@components/absolute-back-button";
import ButtonLink from "@components/button-link";
import CustomImage from "@components/custom-image";
import AppleIcon from "@components/icons/apple-icon";
import ConfirmIcon from "@components/icons/confirm-icon";
import HouseIcon from "@components/icons/house-icon";
import SmileyIcon from "@components/icons/smiley-icon";
import AuthImage from "@features/auth/auth-image";
import AuthItem from "@features/auth/auth-item";
import ScreenScrollView from "@features/scroll-view/screen-scroll-view";
import { useSafeArea } from "@provider/safe-area/use-safe-area";
import { useOrientation } from "@utils";
import { Container, Text, View } from "dripsy";
import * as React from "react";
import { Platform } from "react-native";

import routes from "../../NavigatorRoutes";
import Button from "@components/button";
import { fluentRootBottomTabs, fluentScreen, useNavigation } from "react-native-ridge-navigation";
import { BottomRoots } from "../../Navigator";
import { NavigationRoots } from "../../NavigatorRoots";
import { useStoryBlokStory } from "@provider/storyblok-provider";
import type { AuthStoryblok } from "@type/storyblock-types.d.ts";

export function Advantages({ usp1, usp2, usp3, usp4 }: { usp1?: string; usp2?: string; usp3?: string; usp4?: string }) {
  return (
    <>
      <AuthItem icon={<AppleIcon size={24} color="$textSecondary" />} title={usp1} />
      <AuthItem icon={<ConfirmIcon size={24} color="$textSecondary" />} title={usp2} />
      <AuthItem icon={<SmileyIcon size={24} color="$textSecondary" />} title={usp3} />
      <AuthItem icon={<HouseIcon size={24} color="$textSecondary" />} title={usp4} />
    </>
  );
}

function LoginOrSignupSmallScreen() {
  const insets = useSafeArea();

  const orientation = useOrientation();
  const content = useStoryBlokStory<AuthStoryblok>("account");

  return (
    <>
      <View sx={{ backgroundColor: "$secondaryBackground", flex: 1 }}>
        {orientation === "PORTRAIT" ? <AuthImage /> : null}

        <ScreenScrollView>
          <Container variant="small" sx={{ alignSelf: "center" }}>
            {Platform.OS === "web" ? (
              <View sx={{ marginTop: "$4" }} />
            ) : (
              <CustomImage
                source={dgv}
                sx={{ alignSelf: "center", marginTop: insets.top + 6, width: 138, height: 34, zIndex: -1 }}
                alt="DGV logo"
              />
            )}
            <View sx={{ marginTop: "$4" }}>
              <Advantages usp1={content.usp_1} usp2={content.usp_2} usp3={content.usp_3} usp4={content.usp_4} />
            </View>
            <Spacer />
            <Spacer />
            <ButtonLink to={routes.LoginScreen} params={{}}>
              Inloggen
            </ButtonLink>
            <Spacer />
            <ButtonLink to={routes.CreateAccountScreen} params={{}} outline>
              Nieuwe klant
            </ButtonLink>
            <DevelopmentSignUp />
          </Container>
        </ScreenScrollView>
        {Platform.OS !== "web" && <AbsoluteBackButton />}
      </View>
    </>
  );
}

export function DevelopmentSignUp() {
  const { fluent } = useNavigation();
  if (process.env.NODE_ENV !== "development") {
    return null;
  }
  return (
    <View sx={{ padding: "$3" }}>
      <Text sx={{ margin: "$3" }}>Development only</Text>
      <Button
        onPress={() => {
          fluent(
            fluentRootBottomTabs(NavigationRoots.RootApp, BottomRoots.Account),
            fluentScreen(routes.CreateAccountFormScreen, {
              token: "QD7MzpT6Mhf2XcTECTwo18pJSdVio7kCZk2dMvudOvSAlf2gU48p8TXSBuoqhtoE",
            })
          );
        }}
        outline
      >
        Account registreren (na-email)
      </Button>
      <Spacer />
      <Button
        onPress={() => {
          fluent(
            fluentRootBottomTabs(NavigationRoots.RootApp, BottomRoots.Account),
            fluentScreen(routes.PasswordResetConfirmScreen, {
              email: "test@test.nl",
              token: "9984bca1c4b0b0104827efab8afd75495beda6e4a069643e6978b1e13b10b145",
            })
          );
        }}
        outline
      >
        Wachtwoord opnieuw instellen
      </Button>
    </View>
  );
}

export default LoginOrSignupSmallScreen;
